import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { withApollo, compose } from 'react-apollo'
import { useDispatch, useSelector } from 'react-redux'
import {
  fetchUserPointList
} from '../../modules/reward'

import {
  message,
  Card,
  Table,
  Divider,
  Popconfirm,
  Button,
  Input,
  Icon,
  Tag
} from 'antd'

import { useDeepEffect } from '../../utils/hooks'
import _ from 'lodash'
import Highlighter from 'react-highlight-words'

const UserPoint = () => {
  const dispatch = useDispatch()
  let searchInput = useRef(null)
  const [searchText, setSearchText] = useState('')

  const { userPointItem } = useSelector(
    (state) => ({
      userPointItem: state.reward.userPointList
    }),
    []
  )
  useDeepEffect(() => {
    async function fetch() {
      await dispatch(fetchUserPointList())
    }

    fetch()
  }, [])

  const point = userPointItem.map(
    (point) => point.currentPoint
  )

  const totalPoint = point.reduce((a, b) => a + b, 0)

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput = node
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}>
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select())
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  })

  const handleSearch = (selectedKeys, confirm) => {
    confirm()
    setSearchText(selectedKeys[0])
  }

  const handleReset = (clearFilters) => {
    clearFilters()
    setSearchText('')
  }

  const columns = [
    {
      title: 'ชื่อ',
      dataIndex: 'userName',
      key: 'userName',
      ...getColumnSearchProps('userName'),
      render: (name, row) => (
        <div>
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={name.toString()}
          />
        </div>
      )
    },
    {
      title: 'คะแนน',
      dataIndex: 'currentPoint',
      key: 'currentPoint'
    }
  ]

  return (
    <Card
      title="User Point"
      extra={
        <div>
        <h4>คะแนนรวมทั้งหมด : {totalPoint} </h4> 
      </div>
      }>
      <Table
        scroll={{ x: 500 }}
        rowKey={(record) => record.id}
        dataSource={userPointItem}
        columns={columns}
      />
    </Card>
  )
}
export default compose(
  withApollo
)(UserPoint)



// WEBPACK FOOTER //
// ./src/pages/UserPoint/index.js